import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";

import ApiService from '../services/ApiService';
import { Col, Container, Row } from "react-bootstrap";
import UnityGameComponent from "../components/games/UnityGameComponent";
import PongGameComponent from "../components/games/PongGameComponent";
import LeaderboardWidget from "../components/widgets/LeaderboardWidget";
import ChatWidget from "../components/widgets/ChatWidget";

const PlayGame = () => {
    const { gameId, instanceId } = useParams();
    const [game, setGame] = useState<Game>();

    useEffect(() => {
        let id = gameId;
        if (!id) id = "1";
        ApiService.get(`/games/${id}`).then((response) => {
            if (!response) throw new Error('No response');
            if (response.success)
                setGame(response.data);
            else
                console.log(response.message);
        }).catch((error: any) => {
            console.log(error);
        });
    }, [gameId]);

    return (
        <div className="game-room">
            <Helmet>
                <title>
                    {`Darknet Games | ${game?.name}`}
                </title>
            </Helmet>
            <Container fluid>
                {game && game.id === 1 && (
                    <Row className="justify-content-center g-3 ms-md-5">
                        <Col xs={3} className="d-none d-md-block">
                            <LeaderboardWidget />
                        </Col>
                        <Col xs={12} md={6}>
                            {game && instanceId && (<PongGameComponent instanceId={instanceId} />)}
                        </Col>
                        <Col xs={12} md={3}>
                            <ChatWidget instanceId={instanceId} />
                        </Col>
                    </Row>
                )}
                {game && game.id > 1 && (
                    <Row className="justify-content-center g-3">
                        <Col xs={2}>
                        </Col>
                        <Col xs={6}>
                            {game && (<UnityGameComponent game={game} />)}
                        </Col>
                        <Col xs={2}>
                        </Col>
                    </Row>
                )}
            </Container>
        </div>
    )
}

export default PlayGame;